import React from "react"

export default React.createContext({
  isDemo: false,
  tenantId: null,
  filters: null,
  onBeforeCreate: null,
  schedules: null,
  scheduleOptions: null,
  allTeams: null,
  demoTenantAccessToken: null
})
